import React from 'react';
import ReactDOM from 'react-dom';
import { Form, Input, Row, Col } from 'antd';
const FormItem = Form.Item;
import { bindValue, bindEvent, setFormCtlLayout, AddFormCtlCommonAttribute } from './sgiFormCtlComm';
import { sgiFormCtlBaseFun } from "./sgiFormCtlBaseFun";
import { convertModuleByGuid } from "./SgiCompComm";
import { addCtnCommonAttribute } from "./SgiCtnComm"
// import { addToolbarCtlDndInfo } from '../sgiDndDev/sgiDndDevComFun'

class SgiToolbar extends React.Component {

	static defaultProps = {
	};  // 注意这里有分号
	static propTypes = {
	};  // 注意这里有分号

	constructor(props) {
		super(props);
		//初始化state属性
		// this.initState();
		this.state = {
			// inputprops: { style: { heigth: '100%', width: '100%' } },//存放input属性
			toolbarProps: { style: { padding: '6px 6px 6px 6px' } },
			toolbarItems: [] //工具条下控件数组
		};
	}

	/**
	 * 根据描述创建文本框
	 * @param {父组件} parentModule
	 * @param {组件描述} moduleDesc
	 * @param {绑定实例ID} bdInst
	 * @param {对象工厂} objFct
	 * @param {make类型} type
	 */
	toolBar_mk(parentModule, moduleDesc, bdInst, objFct, type) {

		//获取需要展示的数据信息
		if (!moduleDesc) {
			return;
		}

		this.state.toolbarItems = []; //再次渲染的时候清空

		//转换公共属性
		addCtnCommonAttribute(this, moduleDesc, this.state.toolbarProps);
		//转换基础属性
		this.AddInputAttribute(moduleDesc, this.state.toolbarProps);
		//组装form表单下的控件信息
		if (type !== "dnd") this.fitToolbarItems(moduleDesc, this.state.toolbarItems, objFct, type);
		//添加拖拽布局信息 根据type类型
		// addToolbarCtlDndInfo(this, this.state.toolbarItems, this.state.toolbarProps, type);
		let addToolbarCtlDndInfo = this.props.addToolbarCtlDndInfo;//显示/开发分离，这部分拖拽开发功能使用props传入
		if (addToolbarCtlDndInfo && typeof addToolbarCtlDndInfo === "function") {
			addToolbarCtlDndInfo(this, this.state.toolbarItems, this.state.toolbarProps, this.props.type);
		}
	}


	/**
	 * 根据描述组装子对象
	 * @param {描述信息} moduleDesc
	 * @param {属性} formProps
	 */
	fitToolbarItems = function (moduleDesc, toolbarItems, objFct, type) {
		var tlbAlg = moduleDesc.tlbAlg;//工具条位置  

		var me = this;
		//form下的子节点添加到toolbar组件中
		let cldSet = moduleDesc.cldSet;
		if (cldSet && cldSet.length && cldSet.length > 0) {
			if (!tlbAlg || tlbAlg == "top" || tlbAlg == "bottom") {
				cldSet.forEach((item, index) => {
					toolbarItems.push(convertModuleByGuid(me, item, null, objFct, type));
				});
			} else if (tlbAlg == "left" || tlbAlg == "right") {
				var rowlist = [];
				cldSet.forEach((item, index) => {
					rowlist.push(<Row>{convertModuleByGuid(me, item, null, objFct, type)}</Row>);
				});
				toolbarItems.push(
					<Col>{rowlist}</Col>
				);
			} else {
				cldSet.forEach((item, index) => {
					toolbarItems.push(convertModuleByGuid(me, item, null, objFct, type));
				});
			}
		}
	}

	/**
	 * 设置是否隐藏
	 */
	setHidden(value) {
		if (value) {
			this.state.toolbarProps.style.display = "none"
		} else {
			this.state.toolbarProps.style.display = undefined;
		}
		// if (testReactVsn(this, 16)) {
		// 	// react16需要更新引用
		// 	this.state.formItemProps.style = { ...this.state.formItemProps.style };
		// }
		this.setState(this.state.toolbarProps);
	}


	/**
	 * 属性转换
	 * @param {描述信息} moduleDesc
	 * @param {属性} formItem
	 * @param {属性} inputprops
	 */
	AddInputAttribute(moduleDesc, toolbarProps) {
		var btnAlg = moduleDesc.btnAlg;//按钮位置，左中右
		if (btnAlg) toolbarProps.style['text-align'] = btnAlg;


		var isDis = moduleDesc.isDis;//禁用   

		// var tlbAlg = moduleDesc.tlbAlg;//工具条位置 暂时不事先上下
		// if (tlbAlg == 'left') {
		//     toolbarProps.style.float = "left";
		//     toolbarProps.style.heigth = '100%';
		// } else if (tlbAlg == 'right') {
		//     toolbarProps.style.float = "right";
		//     toolbarProps.style.heigth = '100%';
		// } else {
		//     toolbarProps.style.width = '100%';
		// }
		toolbarProps.style.width = toolbarProps.style.width || '100%';
	}

	refresh = () => {
		this.loaded = false;
		this.setState({ loading: false });
	}

	//渲染并返回一个虚拟DOM
	render = function () {
		if (!this.loaded) {
			var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
			//组装属性 初始化属性到this.state
			this.toolBar_mk(parentModule, moduleDesc, bdInst, objFct, type);
			this.loaded = true;
		}

		return (
			<div {...this.state.toolbarProps}>
				{this.state.toolbarItems}
			</div>
		);
	}
}

export { SgiToolbar };
export default SgiToolbar;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiToolbar.js